import { useTranslate } from "./../hooks/useTranslate";
import { toast } from "react-toastify";

import styles from "../../pages/projects/components/ProjectInfo/projectInfo.module.scss";

/**
 * Copy text to clipboard
 */

const AUTOCLOSE_MS = 500;

export const copyText = async (text: string) => {
  await navigator.clipboard.writeText(text);
  toast("Copied", {
    type: "info",
    position: "bottom-center",
    autoClose: AUTOCLOSE_MS,
    className: styles.copyToast,
    bodyClassName: styles.bodyCopyToast,
    icon: false,
    hideProgressBar: true,
    closeButton: false,
  });
};

export const useCopyText = () => {
  const { t } = useTranslate();
  
  const copyText = async (text: string) => {
    await navigator.clipboard.writeText(text);
    toast(t("Copied"), {
      type: "info",
      position: "bottom-center",
      autoClose: AUTOCLOSE_MS,
      className: styles.copyToast,
      bodyClassName: styles.bodyCopyToast,
      icon: false,
      hideProgressBar: true,
      closeButton: false,
    });
  };
  return copyText;
};
